/* ======================================================================
   PCD – Shopify cart properties + Cloudinary image upload
   ====================================================================== */

var PCD_CLOUD_NAME    = 'vf1x9jd6';
var PCD_UPLOAD_PRESET = 'shopify_uploads';      // must be an UNSIGNED preset in Cloudinary
var PCD_MAX_BYTES     = 10 * 1024 * 1024;       // Cloudinary Free plan image limit (10 MB)
var PCD_FORM_SELECTOR = 'form[action*="cart/add"][method="post"]';


// ── 1. COLOUR CACHE ──────────────────────────────────────────────
var pcdCachedColour = '';

(function () {
  function cacheCurrentColour() {
    var checked = document.querySelector('input[name="properties[Choose Colour]"]:checked');
    if (checked && checked.value) pcdCachedColour = checked.value;
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'properties[Choose Colour]') {
      pcdCachedColour = e.target.value;
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(cacheCurrentColour, 500);

    var productColumn = document.querySelector(
      '.product__info-wrapper, .product-single__meta, [class*="product-"]'
    );
    if (productColumn) {
      new MutationObserver(function () {
        setTimeout(cacheCurrentColour, 50);
      }).observe(productColumn, { childList: true, subtree: true });
    }
  });
})();


// ── 2. AJAX ADD-TO-CART INTERCEPT (installed immediately) ────────
(function () {
  var originalFetch = window.fetch;

  // Adds properties to whatever body format the theme uses
  function addProps(body, props) {
    var keys = Object.keys(props);
    if (!keys.length) return body;

   if (body instanceof FormData || body instanceof URLSearchParams) {
  body.delete('properties[Upload Image]');
  document.querySelectorAll('input[type="hidden"][name^="properties[Upload Image "]').forEach(function(el){
    if (el.value) body.set(el.name, el.value);
  });
  keys.forEach(function(k){
    if (k.indexOf('Upload Image') === -1) body.set('properties[' + k + ']', props[k]);
  });
  return body;
}



    if (typeof body === 'string') {
      // JSON body
      try {
        var json = JSON.parse(body);
        var targets = Array.isArray(json.items) ? json.items : [json];
        targets.forEach(function (t) {
          var safeProps = {};
Object.keys(props).forEach(function(k) {
  if (k === 'Upload Image' && t.properties && t.properties['Upload Image 1']) return;
  safeProps[k] = props[k];
});
t.properties = Object.assign({}, t.properties, safeProps);

        });
        return JSON.stringify(json);
            } catch (e) {
        // URL-encoded string body
        var params = new URLSearchParams(body);
        // Remove old single Upload Image
        params.delete('properties[Upload Image]');
        // Inject numbered upload inputs from DOM
        document.querySelectorAll('input[type="hidden"][name^="properties[Upload Image "]').forEach(function(el) {
          if (el.value) params.set(el.name, el.value);
        });
        // Add other props (skip Upload Image)
        keys.forEach(function(k) {
          if (k !== 'Upload Image') params.set('properties[' + k + ']', props[k]);
        });
        return params.toString();
      }

    }

    return body;
  }

  function send(ctx, input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/cart/add') !== -1 && init && init.body) {
        var props = {};

      var uploadInputs = document.querySelectorAll('input[type="hidden"][name^="properties[Upload Image "]');
if (uploadInputs.length > 0) {
  uploadInputs.forEach(function(el) {
    var key = el.name.replace('properties[', '').replace(']', '');
    if (el.value) props[key] = el.value;
  });
} else {
  var imgEl = document.getElementById('pcd-img');
  if (imgEl && imgEl.value) props['Upload Image'] = imgEl.value;
}


        var checked = document.querySelector('input[name="properties[Choose Colour]"]:checked');
        var colour  = (checked && checked.value) ? checked.value : pcdCachedColour;
        if (colour) props['Choose Colour'] = colour;

        init.body = addProps(init.body, props);
      }
    } catch (e) {
      console.warn('[PCD] fetch intercept error', e);
    }
    return originalFetch.call(ctx, input, init);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var ctx = this;
    // If an image is still uploading, wait for it, then add to cart
    if (url.indexOf('/cart/add') !== -1 && window.pcdUploadPending) {
      return window.pcdUploadPending.then(function () {
        return send(ctx, input, init);
      });
    }
    return send(ctx, input, init);
  };
})();


// ── 3. IMAGE UPLOAD → CLOUDINARY ─────────────────────────────────
(function () {

  function findFileInput() {
    return document.querySelector('input[type="file"].qr-file-input') ||
           document.querySelector('input[type="file"][name="properties[Upload Image]"]') ||
           document.querySelector(PCD_FORM_SELECTOR + ' input[type="file"]') ||
           document.querySelector('input[type="file"]');
  }

  function initPcdImage() {
    if (document.getElementById('pcd-img')) return;

    var fileInput = findFileInput();
    var formEl    = document.querySelector(PCD_FORM_SELECTOR);
    if (!fileInput || !formEl) return;

    // Stop the raw file from being submitted with the form
    fileInput.removeAttribute('name');
    fileInput.removeAttribute('required');

    // Hidden field that carries the Cloudinary URL
    var hidden  = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'properties[Upload Image]';
   hidden.id   = 'pcd-img';
if (!document.querySelector('input[name="properties[Upload Image 1]"]')) {
  formEl.appendChild(hidden);
}


    // Status message under the file input
    var msg = document.createElement('div');
    msg.style.cssText = 'font-size:13px;margin-top:6px;';
    fileInput.parentNode.appendChild(msg);

    function showMsg(text, isError) {
      msg.textContent = text || '';
      msg.style.color = isError ? '#c00' : '#555';
    }

    console.log('[PCD] Ready ✅ form:', formEl.id || formEl.action);

    fileInput.addEventListener('change', function (e) {
      var file = e.target.files[0];
      hidden.value = '';
      showMsg('');
      if (!file) return;

      if (file.size > PCD_MAX_BYTES) {
        showMsg('Image is too large (max 10 MB). Please choose a smaller file.', true);
        fileInput.value = '';
        return;
      }

      showMsg('Uploading image…');

      var formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', PCD_UPLOAD_PRESET);

      window.pcdUploadPending = fetch('https://api.cloudinary.com/v1_1/' + PCD_CLOUD_NAME + '/image/upload', {
        method: 'POST',
        body: formData
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (r) {
          if (r.ok && r.data.secure_url) {
            hidden.value = r.data.secure_url;
            showMsg('Image uploaded ✓');
            console.log('[PCD] Cloudinary upload ✅', r.data.secure_url);
          } else {
            var reason = (r.data && r.data.error && r.data.error.message) || 'Upload failed';
            throw new Error(reason);
          }
        })
        .catch(function (err) {
          console.error('[PCD] Upload failed:', err);
          showMsg('Image upload failed: ' + err.message, true);
          fileInput.value = '';
        })
        .then(function () {
          window.pcdUploadPending = null;
        });
    }, true);

    // Non-AJAX themes: if the form is submitted mid-upload, wait then resubmit
    formEl.addEventListener('submit', function (e) {
      if (window.pcdUploadPending) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.pcdUploadPending.then(function () {
          if (formEl.requestSubmit) formEl.requestSubmit();
          else formEl.submit();
        });
      }
    }, true);

    // Restore image when editing a cart line
    var editKey = new URLSearchParams(window.location.search).get('edit_line');
    if (editKey) {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var item = cart.items.find(function (i) { return i.key === editKey; });
          var img  = item && item.properties && item.properties['Upload Image'];
          if (!img) return;
          setTimeout(function () {
            hidden.value = img;
            
            console.log('[PCD] Image restored ✅');
          }, 1000);
        })
        .catch(function (err) { console.warn('[PCD] restore failed', err); });
    }
  }

  function tryInitPcdImage() {
    if (document.getElementById('pcd-img')) return;
    if (document.querySelector(PCD_FORM_SELECTOR) && findFileInput()) {
      initPcdImage();
      return;
    }
    var observer = new MutationObserver(function () {
      if (document.querySelector(PCD_FORM_SELECTOR) && findFileInput()) {
        observer.disconnect();
        initPcdImage();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInitPcdImage);
  } else {
    tryInitPcdImage();
  }
})();


// ── 4. SYNC OUTSIDE-FORM FIELDS → HIDDEN INPUTS INSIDE FORM ──────
(function () {

  function bindOutsideField(form, field) {
    if (form.contains(field)) return;
    if (field.type === 'file' || field.type === 'hidden') return;

    var rawName = field.getAttribute('name') || field.getAttribute('data-property') || '';
    var key = rawName.replace('properties[', '').replace(/\]$/, '');
    if (!key) return;

    var hiddenId = 'pcd-sync-' + key.replace(/\s+/g, '-').toLowerCase();
    var hidden = form.querySelector('#' + hiddenId);
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[' + key + ']';
      hidden.id   = hiddenId;
      form.appendChild(hidden);
    }

    if (field.value) hidden.value = field.value;

    ['input', 'change', 'keyup'].forEach(function (evt) {
      field.addEventListener(evt, function () {
        hidden.value = field.value;
      });
    });
  }

  function initSync(form) {
    document.querySelectorAll(
      '[name^="properties["]:not([type="hidden"]):not([type="file"]),' +
      '[data-property],' +
      '#printcord-name'
    ).forEach(function (field) { bindOutsideField(form, field); });
  }

  function start() {
    var form = document.querySelector(PCD_FORM_SELECTOR);
    if (form) {
      setTimeout(function () { initSync(form); }, 500);
      return;
    }
    var observer = new MutationObserver(function () {
      var f = document.querySelector(PCD_FORM_SELECTOR);
      if (f) {
        observer.disconnect();
        setTimeout(function () { initSync(f); }, 500);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


// ── 5. SYNC COLOUR RADIOS → HIDDEN INPUT (if one exists in form) ─
(function () {
  function syncColours() {
    var colourHidden = document.querySelector(
      PCD_FORM_SELECTOR + ' input[type="hidden"][name="properties[Choose Colour]"]'
    );
    if (!colourHidden) return;

    document.querySelectorAll('input[type="radio"][name="properties[Choose Colour]"]')
      .forEach(function (radio) {
        radio.addEventListener('change', function () {
          colourHidden.value = radio.value;
        });
        if (radio.checked) colourHidden.value = radio.value;
      });
  }

  setTimeout(syncColours, 600);
})();


// document.addEventListener('DOMContentLoaded', function () {

//   const form = document.querySelector('form[action="/cart/add"]');
//   if (!form) return;

//   // ── CACHE selected colour whenever it changes ──────────────────────
//   // Survives variant re-renders that wipe the colour field DOM.
//   let cachedColour = '';

//   function cacheCurrentColour() {
//     const checked = document.querySelector(
//       'input[name="properties[Choose Colour]"]:checked'
//     );
//     if (checked && checked.value) {
//       cachedColour = checked.value;
//     }
//   }

//   // Listen at document level — catches radios outside the <form> element
//   document.addEventListener('change', function (e) {
//     if (e.target && e.target.name === 'properties[Choose Colour]') {
//       cachedColour = e.target.value;
//     }
//   });

//   // Read on load (after pcd-edit-restore.js has had time to restore)
//   setTimeout(cacheCurrentColour, 500);

//   // Re-cache after variant re-renders (DOM swap by global.js)
//   const productColumn = document.querySelector(
//     '.product__info-wrapper, .product-single__meta, [class*="product-"]'
//   );
//   if (productColumn) {
//     const observer = new MutationObserver(function () {
//       setTimeout(cacheCurrentColour, 50);
//     });
//     observer.observe(productColumn, { childList: true, subtree: true });
//   }

//   // ── FORM SUBMIT ─────────────────────────────────────────────────────
//   form.addEventListener('submit', function () {           // ← FIXED: submit handler wraps all inject logic

//     // Clean up previously injected hidden inputs
//     form.querySelectorAll('.pcd-injected-prop').forEach(function (el) {
//       el.remove();
//     });

//     // 1. IMAGE FILENAME (badge designer)
//     const imageInput = document.getElementById('pcdImageUpload');
//     if (imageInput && imageInput.files.length > 0) {
//       inject(form, 'Uploaded Image', imageInput.files[0].name);
//     }

//     // 2. CHOOSE COLOUR
//     // Prefer live DOM checked radio; fall back to cached value
//     const checkedColour = document.querySelector(
//       'input[name="properties[Choose Colour]"]:checked'
//     );
//     const colourToSave = (checkedColour && checkedColour.value)
//       ? checkedColour.value
//       : cachedColour;

//     if (colourToSave) {
//       inject(form, 'Choose Colour', colourToSave);
//     }

//     // 3. ALL OTHER data-property FIELDS
//     document.querySelectorAll('[data-property]').forEach(function (el) {
//       const val = el.value ? el.value.trim() : '';
//       if (val) {
//         inject(form, el.getAttribute('data-property'), val);
//       }
//     });

//   });                                                     // ← FIXED: correctly closes submit handler

//   // ── HELPER ──────────────────────────────────────────────────────────
//   function inject(form, name, value) {
//     const input     = document.createElement('input');
//     input.type      = 'hidden';
//     input.name      = 'properties[' + name + ']';
//     input.value     = value;
//     input.className = 'pcd-injected-prop';
//     form.appendChild(input);
//   }

// });                                                       // ← closes DOMContentLoaded


// // ── PCD IMAGE UPLOAD ────────────────────────────────────────────
// (function() {
//   function initPcdImage() {
//     // ✅ FIX 1: Broader selector — works regardless of class name
//     var fileInput = document.querySelector(
//       'input[type="file"].qr-file-input, ' +
//       'input[type="file"][name="properties[Upload Image]"], ' +
//       'input[type="file"]'
//     );
//     if (!fileInput) return;

//     // Get form via form attribute ID
//     var formId = fileInput.getAttribute('form');
//     var formEl = formId ? document.getElementById(formId) : document.querySelector('form[action*="/cart/add"]');
//     if (!formEl) {
//       // Last resort — walk up DOM
//       formEl = fileInput.closest('form');
//     }
//     if (!formEl) { console.warn('[PCD] form not found'); return; }
//     if (document.getElementById('pcd-img')) return;

//     fileInput.removeAttribute('name');

//     var hidden  = document.createElement('input');
//     hidden.type = 'hidden';
//     hidden.name = 'properties[Upload Image]';
//     hidden.id   = 'pcd-img';
//     formEl.appendChild(hidden);
//     console.log('[PCD] Ready ✅ form:', formEl.id || formEl.action);

//     var imageReady = true;

//     fileInput.addEventListener('change', function(e) {
//       var file = e.target.files[0];
//       if (!file) return;
//       imageReady = false;
//       var reader = new FileReader();
//       reader.onload = function(ev) {
//         var img = new Image();
//         img.onload = function() {
//           var MAX = 200, scale = Math.min(1, MAX / Math.max(img.width, img.height));
//           var c = document.createElement('canvas');
//           c.width  = Math.round(img.width  * scale);
//           c.height = Math.round(img.height * scale);
//           c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
//           var b64 = c.toDataURL('image/jpeg', 0.5);
//           if (b64.length > 40000) {
//             var c2 = document.createElement('canvas');
//             c2.width  = Math.round(c.width  * 0.5);
//             c2.height = Math.round(c.height * 0.5);
//             c2.getContext('2d').drawImage(c, 0, 0, c2.width, c2.height);
//             b64 = c2.toDataURL('image/jpeg', 0.4);
//           }
//           hidden.value = b64;
//           imageReady   = true;
//           console.log('[PCD] Image ready ✅ length:', b64.length);
//         };
//         img.src = ev.target.result;
//       };
//       reader.readAsDataURL(file);
//     }, true);

//     formEl.addEventListener('submit', function(e) {
//       if (!imageReady) {
//         e.preventDefault();
//         e.stopImmediatePropagation();
//         var wait = setInterval(function() {
//           if (imageReady) {
//             clearInterval(wait);
//             formEl.dispatchEvent(new Event('submit', {bubbles:true,cancelable:true}));
//           }
//         }, 100);
//       }
//     }, true);

//     // Restore on edit
//     var editKey = new URLSearchParams(window.location.search).get('edit_line');
//     if (editKey) {
//       fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
//         var item = cart.items.find(function(i){return i.key===editKey;});
//         if (!item) return;
//         var img = item.properties && item.properties['Upload Image'];
//         if (!img) return;
//         setTimeout(function(){
//           hidden.value = img;
//           console.log('[PCD] Image restored ✅');
//         }, 1000);
//       });
//     }
//   }

//   // ✅ FIX 2: Increased delay to 800ms for slow-rendering templates
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initPcdImage);
//   } else {
//     setTimeout(initPcdImage, 800);
//   }

// })();
// // ── END PCD IMAGE UPLOAD ──────────────────────


// // ── SYNC OUTSIDE-FORM FIELDS → HIDDEN INPUTS INSIDE FORM ──────────────────
// (function syncOutsideFields() {

//   var form = document.querySelector('form[action="/cart/add"]');
//   if (!form) return;

//   function bindOutsideField(field) {
//     if (form.contains(field)) return;
//     if (field.type === 'file') return;
//     if (field.type === 'hidden') return;

//     var rawName = field.getAttribute('name') || field.getAttribute('data-property') || '';
//     var key = rawName.replace('properties[', '').replace(']', '');
//     if (!key) return;

//     var hiddenId = 'pcd-sync-' + key.replace(/\s+/g, '-').toLowerCase();
//     var hidden = form.querySelector('#' + hiddenId);
//     if (!hidden) {
//       hidden = document.createElement('input');
//       hidden.type = 'hidden';
//       hidden.name = 'properties[' + key + ']';
//       hidden.id = hiddenId;
//       form.appendChild(hidden);
//     }

//     // Sync current value immediately
//     if (field.value) hidden.value = field.value;

//     // ✅ FIX 3: Listen on all 3 events to never miss a value
//     ['input', 'change', 'keyup'].forEach(function(evt) {
//       field.addEventListener(evt, function() {
//         hidden.value = field.value;
//         console.log('[PCD sync] ' + key + ' → "' + field.value + '"');
//       });
//     });
//   }

//   function initSync() {
//     document.querySelectorAll(
//       '[name^="properties["]:not([type="hidden"]):not([type="file"]),' +
//       '[data-property],' +
//       '#printcord-name'
//     ).forEach(bindOutsideField);
//   }

//   // ✅ FIX 4: Delay sync init so DOM fields are rendered first
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', function() { setTimeout(initSync, 500); });
//   } else {
//     setTimeout(initSync, 500);
//   }

// })();
// // ── END SYNC OUTSIDE-FORM FIELDS ──────────────────────────────────────────

// // ── SYNC COLOUR RADIOS → HIDDEN INPUT ─────────────────────────
// (function() {
//   function syncColours() {
//     var colourHidden = document.querySelector(
//       'form[action*="cart/add"] input[name="properties[Choose Colour]"]'
//     );
//     if (!colourHidden) return;

//     document.querySelectorAll('input[type="radio"][name="properties[Choose Colour]"]')
//       .forEach(function(radio) {
//         radio.addEventListener('change', function() {
//           colourHidden.value = radio.value;
//           console.log('[PCD] Colour synced:', radio.value);
//         });
//         // Sync if already checked
//         if (radio.checked) colourHidden.value = radio.value;
//       });
//   }

//   setTimeout(syncColours, 600);
// })();
